// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".row-label-disabled[data-v-52434188] {\n  color: #999;\n}\n[data-v-52434188] .el-table__row.row-disabled {\n  background-color: #fafafa;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
